import React, { useState } from 'react';
import { Expand } from 'components/core/Expand';
import { Button } from 'components/core/Button';
import { Text } from 'components/core/Text';
import Plus from 'components/svg/Plus';
import Minus from 'components/svg/Minus';
import PropTypes from 'prop-types';

import './UnitReservationFeeDropDown.scss';

function UnitReservationFeeDropDown({
	fees,
	price
}) {
	const [show, setShow] = useState(false);

	const toggleShow = () => setShow((prev) => !prev);

	let feeDetails = [
		{
			name: 'One-Time Admin Fee',
			price: fees?.admin?.value
		},
		{
			name: 'One-Time Lock Fee',
			price: fees?.lock?.value
		}
	];

	feeDetails = feeDetails.filter((fee) => fee.price > 0);

	const totalFee = fees?.totalFees?.value || 0;
	const priceTotal = price?.value || 0;

	const totalCost = (totalFee + priceTotal).toFixed(2);

	return (
		<div className="main-fees-container">
			<div>
				<Text color="gray" weight="ultraBold">
					The following fees shall apply:
				</Text>

				<ul>
					{feeDetails.map((fee) => (
						<li key={fee.name}>{`${fee.name}: $${fee.price}`}</li>
					))}
				</ul>
				<Text color="gray">
					Your first month's bill will be ${totalCost} plus taxes.
				</Text>
			</div>

			<div className="trigger-container">
				{show ? <Minus /> : <Plus />}

				<Button
					onClick={toggleShow}
					link
				>
					<Text color="gray">
						{show ?
							'Close Details About Admin Fees' :
							'Read More About Admin Fee'}
					</Text>
				</Button>
			</div>

			<Expand showing={show}>
				<div>
					<Text size="small" color="gray" weight="standard">
						The one-time, non-refundable admin fee is charged upon
						signing your lease agreement. This fee covers the costs
						associated with processing your application and setting
						up your account and access credentials, ensuring a
						smooth move-in process.
					</Text>
				</div>
			</Expand>
		</div>
	);
}

UnitReservationFeeDropDown.propTypes = {
	fees: PropTypes.object,
	price: PropTypes.object
};

export default UnitReservationFeeDropDown;
